import { css } from "@emotion/react";

import { colors } from "../../styles";

export const contact = css`
  padding: 20px;
`;

export const header = css`
  font-size: 1.2em;
`;

export const form = css`
  @media only screen and (max-width: 40em) {
    padding-top: 40px;
  }
`;

export const locationList = css`
  list-style: none;
  margin-left: 0;

  li {
    padding: 5px 0;
  }
`;

export const address = css`
  font-style: normal;
`;

export const mapMarker = css`
  margin-right: 7px;
  color: ${colors.primary};
`;

export const img = css`
  border-radius: 5px;
`;
